import { Settings } from 'lucide-react'

interface HeaderProps {
  onSettings?: (() => void) | undefined
  showSettings?: boolean
}

export function Header({ onSettings, showSettings = true }: HeaderProps) {
  return (
    <header className="flex items-center justify-between px-4 py-3 border-b border-secondary-200 bg-white shrink-0">
      <div className="flex items-center gap-2">
        {/* Athenty diamond logo */}
        <div className="w-6 h-6 rounded bg-brand-gradient flex items-center justify-center shrink-0">
          <svg viewBox="0 0 100 100" className="w-4 h-4 fill-white">
            <polygon points="50,10 90,50 50,90 10,50" opacity="0.9" />
            <polygon points="50,28 72,50 50,72 28,50" className="fill-[#2F6CAA]" />
          </svg>
        </div>
        <span className="text-sm font-semibold text-secondary-900">Matter Planner</span>
      </div>

      {showSettings && onSettings && (
        <button
          onClick={onSettings}
          className="p-1.5 rounded-md text-secondary-400 hover:text-secondary-600 hover:bg-secondary-100 transition-colors"
          aria-label="Settings"
        >
          <Settings size={15} />
        </button>
      )}
    </header>
  )
}
